import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { Observable } from 'rxjs';
import { queue } from 'src/app/dashboards/models';
import { register } from 'src/app/dashboards/widget/widget-helpers/helpers';
import { traffic } from 'src/app/enums';
import { gridItem, property } from 'src/app/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { WidgetBaseComponent } from '../../widget-base.component';

@Component({
    selector: 'app-calls-wizard',
    templateUrl: './calls-wizard.component.html',
    styleUrls: ['./calls-wizard.component.scss'],
    standalone: false
})
@register("Calls_wizard")
export class CallsWizardComponent implements OnInit, WidgetBaseComponent {
  @Input() public gridItem:gridItem;  
  @Input() public isEdit: boolean; 
  @Output() public completed = new EventEmitter<boolean>();

  queues$: Observable<queue[]>;
  callProperties: property[] = Object.keys(traffic).filter(key=>isNaN(Number(key))).map(key => ({ id: traffic[key], name: key }));

  constructor(private DashboardsService: DashboardService, private i18nextPipe: I18NextPipe) { }

  ngOnInit(): void {
    this.queues$ = this.DashboardsService.getAllQueues(); 
    setTimeout(() => this.modelChange(), 0);
    if (!this.isEdit) {
      this.gridItem.cols = 12;
      this.gridItem.rows = 6;
    }
  }

  modelChange() {
    let completed = this.gridItem.setup.queueIds?.length > 0
      && this.gridItem.setup.traficIds?.length > 0
      && this.gridItem.type != null;
    this.completed.emit(completed);
  }
}
